export default "__VITE_ASSET__8etdOAco__"